import { ENDPOINTS } from "@api/endpoints";
import HttpClient from "@api/HttpClient";

import { marketoQueryParam } from "@constants/queryParameters";

import { ThemesRes } from "types/responses";

export type createThemePostData = {
  name: string;
  primary_color: string;
  custom_font: string;
  topbar_color: string;
  sidebar_color: string;
  buttons_color: string;
  background_color: string;
  buttons_rounded?: boolean;
  branch_id?: string;
};

export const getThemes = async (branchId?: string): Promise<ThemesRes> => {
  // By calling this method, a Marketo event will be automatically triggered.
  const queryFromBranch = branchId ? `&branch_id=${branchId}` : "";

  const queryStr = `${ENDPOINTS.themes.themes}?${marketoQueryParam}${queryFromBranch}`;

  const res = await HttpClient.get(queryStr);

  return res.data;
};

export const createTheme = async (data: createThemePostData): Promise<void> => {
  await HttpClient.post(ENDPOINTS.themes.create, data);
};

export const updateTheme = async (themeId: string, data: createThemePostData): Promise<void> => {
  await HttpClient.patch(ENDPOINTS.themes.edit(themeId), data);
};

export const putActiveTheme = async (themeId: string): Promise<void> => {
  await HttpClient.put(ENDPOINTS.themes.active(themeId));
};

export const putActiveThemeForBranch = async (themeId: string, branchId: string): Promise<void> => {
  await HttpClient.put(ENDPOINTS.themes.activeForBranch(themeId, branchId));
};

export const deleteTheme = async (themeId: string): Promise<void> => {
  await HttpClient.delete(ENDPOINTS.themes.delete(themeId));
};

export const resetTheme = async (themeId: string, branchId: string): Promise<void> => {
  await HttpClient.patch(ENDPOINTS.themes.reset(themeId, branchId));
};
